module.exports = __webpack_public_path__ + "img/richa.1f21e05d.png";